import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGameQuery } from "../settings/Settings.state";
import { Refresher, SidebarLayout } from "../common";
import { Row } from "../App.styles";
import LibraryPreview from "./LibraryPreview";
import LibraryForm from "./LibraryForm";
import LibraryPlaceholder from "./LibraryPlaceholder";
import { withPlaceholder } from "../common";

const Library = () => {
  const { t } = useTranslation();
  const { game_id } = useParams();
  const [{ library_enabled }] = useGameQuery(game_id);

  return (
    <Row>
      <SidebarLayout message={t("Our curators maintain this library of premium challenges. Once unlocked, you can search this library of fan favorites and with one tap add them directly to your game.")}>
        {!library_enabled && <LibraryPreview />}
        {library_enabled && <LibraryForm />}
        <Refresher />
      </SidebarLayout>
    </Row>
  );
};

export default withPlaceholder(Library, LibraryPlaceholder);
